export const storage101 = {
	menuName: "Storage 101",
	links: [
		{
			text: "Size Guide",
			href: "/self-storage-size-guide/"
		},
		{
			text: "Indoor vs. Outdoor Storage",
			href: "/indoor-vs-outdoor/"
		},
		{
			text: "Storage Security",
			href: "/storage-security/"
		},
		{
			text: "Storage Insurance",
			href: "/storage-insurance/"
		}
	]
};

export const storageTypes = {
	menuName: "Storage Types",
	links: [
		{
			text: "Size Guide",
			href: "/self-storage-size-guide/"
		},
		{
			text: "Self Storage",
			href: "/storage-solutions/what-are-storage-units/"
		},
		{
			text: "Vehicle Storage",
			submenu: [
				{
					text: "Car Storage",
					href: "/storage-solutions/car-storage-units/"
				},
				{
					text: "RV Storage",
					href: "/storage-solutions/rv-storage-units/"
				},
				{
					text: "Boat Storage",
					href: "/storage-solutions/boat-storage-units/"
				},
				{
					text: "Motorcycle Storage",
					href: "/storage-solutions/motorcycle-storage-units/"
				}
			]
		},
		{
			text: "Climate Controlled Storage",
			href: "/storage-solutions/climate-controlled-storage-units/"
		},
		{
			text: "College Storage",
			href: "/storage-solutions/college-storage-units/"
		},
		{
			text: "Business Storage",
			href: "/storage-solutions/business-storage-units/"
		}
	]
};
